var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 110 110",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#e04f5f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 26.84A3.84 3.84 0 0 1 34.84 23H63l16 13.44v46.72A3.84 3.84 0 0 1 75.16 87H34.84A3.84 3.84 0 0 1 31 83.16V26.84z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v9.6a3.84 3.84 0 0 0 3.84 3.84H79",
    fill: "#e2e4e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.911 61.067c-.466-.311-1.073-.347-1.666-.101l-6.512 2.713V61.08a2.23 2.23 0 0 0-2.228-2.228H40.713a2.23 2.23 0 0 0-2.228 2.228v11.881a2.23 2.23 0 0 0 2.228 2.228h20.793a2.23 2.23 0 0 0 2.228-2.228v-2.599l6.512 2.713c.26.109.522.162.775.162.323 0 .63-.089.891-.263.466-.31.733-.856.733-1.498v-8.911c-.001-.642-.268-1.188-.734-1.498zm-28.228-3.7a6.69 6.69 0 0 0 6.683-6.683 6.69 6.69 0 0 0-6.683-6.683A6.69 6.69 0 0 0 37 50.683a6.69 6.69 0 0 0 6.683 6.684zm12.624 0c2.457 0 4.456-1.999 4.456-4.456s-1.999-4.456-4.456-4.456-4.456 1.999-4.456 4.456 1.999 4.456 4.456 4.456z",
    fill: "#3e3e3f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileVideo);
export default __webpack_public_path__ + "static/media/file-video.19d85b3d62aa95d35ea1c44437112da7.svg";
export { ForwardRef as ReactComponent };